import { TbiBankIcon } from './icons'
import { trustItems, TBI_CARD_HREF, REWARD_POINTS_HREF } from './trustItems'
import { RewardStarIcon, TextLink } from '../../../UiBlocks'

const CARD_CLASSES = 'rounded-lg border border-border-color bg-white shadow-sm'

/**
 * TrustBar — homepage USP / trust strip (TSS-535)
 *
 * Surfaces 7 badges directly under the hero banner: the 5 hardcoded trust USPs
 * (secure checkout, support, warranty, free shipping, returns), a TBI "Plată în
 * rate" card (links to /cum-cumpar.html#rate-tbi) carrying the inline TBI Bank
 * FusionPay logo, and a reward-points card (links to
 * /termeni-si-conditii#puncte-bonus). Content is HARDCODED by design (see
 * ./trustItems): these badges effectively never change, so no admin CRUD.
 */
export function TrustBar() {
  return (
    <ul className="grid grid-cols-2 gap-2 rounded-lg sm:grid-cols-3 md:gap-3 lg:grid-cols-7">
      {trustItems.map(({ id, Icon, text, href, nofollow }) => (
        <li key={id} className={CARD_CLASSES}>
          <TextLink
            href={href}
            rel={nofollow ? 'nofollow' : undefined}
            size="sm"
            className="flex h-full items-center justify-center gap-3 px-4 py-5 text-black hover:text-black focus:text-black active:text-black visited:text-black"
          >
            <span className="shrink-0 text-custom-red">
              <Icon />
            </span>
            <span className="font-main-font text-sm font-bold leading-tight xl:text-base">
              {text}
            </span>
          </TextLink>
        </li>
      ))}

      {/* TBI instalments — links to the "cum cumpăr" page, FusionPay logo inline.
          Anchor #rate-tbi is added on the target page via PageBuilder. */}
      <li className={CARD_CLASSES}>
        <TextLink
          href={TBI_CARD_HREF}
          size="sm"
          className="flex h-full items-center justify-center gap-3 px-4 py-5 text-black hover:text-black focus:text-black active:text-black visited:text-black"
        >
          <TbiBankIcon />
          <span className="font-main-font text-sm font-bold leading-tight xl:text-base">
            Plată în rate
          </span>
        </TextLink>
      </li>

      {/* Reward points — spans both mobile columns, then joins the desktop row.
          Anchor #puncte-bonus is added on the target page via PageBuilder. */}
      <li className={`${CARD_CLASSES} col-span-2 sm:col-span-3 lg:col-span-1`}>
        <TextLink
          href={REWARD_POINTS_HREF}
          rel="nofollow"
          size="sm"
          className="flex h-full items-center justify-center gap-3 px-4 py-5 text-black hover:text-black focus:text-black active:text-black visited:text-black"
        >
          <RewardStarIcon className="h-7 w-7 shrink-0 text-custom-green xl:h-8 xl:w-8" />
          <div className="flex flex-col items-start justify-center leading-tight">
            <span className="font-main-font text-sm font-bold text-text-color xl:text-base">
              Puncte bonus
            </span>
            <span className="font-main-font text-xs font-medium text-custom-green xl:text-sm">
              la cumpărături
            </span>
          </div>
        </TextLink>
      </li>
    </ul>
  )
}
